// security.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
    // Temporarily disable security headers for Google Maps debugging
    private readonly DISABLE_FOR_MAPS_TESTING = false;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Temporary bypass for Google Maps testing - set to false in production
        if (this.DISABLE_FOR_MAPS_TESTING) {
            return next.handle(request);
        }

        // Don't add security headers to Google Maps requests
        if (request.url.includes('googleapis.com') ||
            request.url.includes('google.com') ||
            request.url.includes('gstatic.com')) {
            return next.handle(request);
        }

        // Clone the request and add security headers only for our app's requests
        const secureRequest = request.clone({
            setHeaders: {
                // Allow Google Maps and other trusted domains to be embedded in iframes
                'X-Frame-Options': 'SAMEORIGIN',
                'X-XSS-Protection': '1; mode=block',
                'X-Content-Type-Options': 'nosniff',
                // Allow Google Maps domains in CSP - comprehensive policy for all Google Maps resources
                'Content-Security-Policy': "default-src 'self'; frame-src 'self' https://maps.google.com https://*.googleapis.com https://*.google.com https://*.gstatic.com; connect-src 'self' https://*.googleapis.com https://*.google.com https://*.gstatic.com https://maps.googleapis.com https://www.google.com http://apipcskiosk1.katdev.com; img-src 'self' data: blob: https://*.googleapis.com https://*.google.com https://*.gstatic.com https://maps.googleapis.com https://www.google.com; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://*.googleapis.com https://*.google.com https://*.gstatic.com; style-src 'self' 'unsafe-inline' https://*.googleapis.com https://*.google.com https://*.gstatic.com; child-src 'self' https://maps.google.com https://*.googleapis.com; worker-src 'self' blob:"
            }
        });

        // Pass the cloned request instead of the original request to the next handle
        return next.handle(secureRequest);
    }
}